import { SidebarModule } from '@/config/permissions'
import { useModuleAccess } from '@/hooks/use-module-access'
import { Main } from '@/components/layout/main'
import { AutomationDialogs } from './components/automation-dialogs'
import { AutomationsPrimaryButtons } from './components/automations-primary-buttons'
import { AutomationsDataTable } from './components/data-table'
import AutomationsProvider from './context/automations-context'

export default function Automations() {
  useModuleAccess(SidebarModule.AUTOMATIONS)
  return (
    <AutomationsProvider>
      <Main>
        <div className='flex flex-wrap items-center justify-between mb-2 space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Automações</h2>
            <p className='text-muted-foreground'>
              Gerencie triggers de automação para WhatsApp que disparam fluxos e
              agentes de IA.
            </p>
          </div>
          <AutomationsPrimaryButtons />
        </div>
        <div className='flex-1 px-4 py-1 -mx-4 overflow-auto lg:flex-row lg:space-x-12 lg:space-y-0'>
          <AutomationsDataTable />
        </div>
      </Main>

      <AutomationDialogs />
    </AutomationsProvider>
  )
}
